import React, { useState, useEffect } from 'react';
// Script Path & Filename: frontend/src/App.jsx
import { Login } from './components/Login';
import { Dashboard } from './components/Dashboard';

export default function App() {
    const [token, setToken] = useState(null);
    const [user, setUser] = useState(null);

    const sessionExpiredRef = React.useRef(false);

    useEffect(() => {
        const storedToken = localStorage.getItem('sapphire_token');
        const storedUser = localStorage.getItem('sapphire_user');
        if (storedToken) setToken(storedToken);
        if (storedUser) {
            try {
                setUser(JSON.parse(storedUser));
            } catch (e) {
                console.error("Failed to parse user from local storage");
            }
        }

        // Global fetch interceptor to catch 401s and force logout
        const originalFetch = window.fetch;
        window.fetch = async function(...args) {
            const response = await originalFetch.apply(this, args);
            if (response.status === 401 && !sessionExpiredRef.current) {
                sessionExpiredRef.current = true;
                console.warn('Session expired or unauthorized (401). Forcing logout.');
                localStorage.removeItem('sapphire_token');
                localStorage.removeItem('sapphire_user');
                setToken(null);
                setUser(null);
            }
            return response;
        };

        return () => {
            window.fetch = originalFetch;
        };
    }, []);

    const handleLogin = (data) => {
        localStorage.setItem('sapphire_token', data.token);
        localStorage.setItem('sapphire_user', JSON.stringify(data.user));
        setToken(data.token);
        setUser(data.user);
    };

    const handleLogout = () => {
        localStorage.removeItem('sapphire_token');
        localStorage.removeItem('sapphire_user');
        setToken(null);
        setUser(null);
    };

    if (!token) return <Login onLogin={handleLogin} />;
    return <Dashboard user={user} token={token} onLogout={handleLogout} />;
}